<template>
	<fieldset
		:disabled="disabledByWizard || disabled"
		style="height: unset"
		:class="componentClassName"
		v-if="useSquare"
		class="input-checkbox-container"
	>
		<label
			:class="labelClassName"
			ref="inputCheckbox"
		>
			<div
				class="checkbox"
				:class="{ disabled: disabled }"
			>
				<div
					class="selectedBox"
					v-if="isInputSelected"
				/>
			</div>
			<template v-if="!visualOnly">
				<input
					v-if="isControlled"
					type="checkbox"
					:style="{
						opacity: '0',
						width: '0',
						height: '0',
						position: 'absolute',
					}"
					@change="onChangeHandler"
					@click="onClickHandler"
				/>
				<input
					v-else
					type="checkbox"
					v-model="vm.isSelected"
					:style="{
						opacity: '0',
						width: '0',
						height: '0',
						position: 'absolute',
					}"
					@change="onChangeHandler"
					@click="onClickHandler"
				/>
			</template>
			<span
				class="ic-label"
				:disabled="disabled"
				:class="{ disabled: disabled }"
			>
				{{ label === '_' ? '\u00A0' : label }}
			</span>
		</label>

		<div class="saturn-textbox-error-message">
			<slot
				v-if="util.hasKey($slots, 'validation')"
				name="validation"
			></slot>
		</div>
	</fieldset>
	<fieldset
		:disabled="disabledByWizard || disabled"
		style="height: unset"
		:class="componentClassName"
		v-else
	>
		<label
			:class="labelClassName"
			ref="inputCheckbox"
		>
			<span class="ic-icons">
				<span
					v-show="isInputSelected == false"
					:disabled="disabled"
					:class="{ disabled: disabled }"
					><i class="far fa-square"></i
				></span>
				<span
					v-show="isInputSelected == true"
					:disabled="disabled"
					:class="{ disabled: disabled }"
				>
					<i
						v-if="!tooltipText"
						class="far fa-check-square"
					></i>
					<span
						v-if="tooltipText"
						:size="10"
						class="hovered-desc left"
						:data-title="tooltipText"
						:include-dot="true"
						><i class="far fa-check-square"></i
					></span>
				</span>
				<template v-if="!visualOnly">
					<input
						v-if="isControlled"
						type="checkbox"
						:style="{
							opacity: '0',
							width: '0',
							height: '0',
							position: 'absolute',
						}"
						:disabled="disabled"
						:class="{ disabled: disabled }"
						@change="onChangeHandler"
						@click="onClickHandler"
					/>
					<input
						v-else
						type="checkbox"
						v-model="vm.isSelected"
						:style="{
							opacity: '0',
							width: '0',
							height: '0',
							position: 'absolute',
						}"
						:disabled="disabled"
						:class="{ disabled: disabled }"
						@change="onChangeHandler"
						@click="onClickHandler"
					/>
				</template>
			</span>
			<span
				v-if="label"
				:disabled="disabled"
				:class="{ 'ic-label': true, disabled: disabled }"
			>
				{{ label === '_' ? '\u00A0' : label }}
			</span>
		</label>

		<div class="saturn-textbox-error-message">
			<slot
				v-if="util.hasKey($slots, 'validation')"
				name="validation"
			></slot>
		</div>
	</fieldset>
</template>

<script>
	import util from '@core/services/util';

	export default {
		name: 'InputCheckbox',
		inject: {
			wizardLocks: {
				// Provided by FIMenuWizardContent
				from: 'fiMenuFieldLocks',
				default: () => null,
			},
		},
		emits: ['blur', 'change', 'click', 'input', 'focus', 'update:modelValue', 'update:saturn'],
		props: ['modelValue', 'label', 'disabled', 'sfx', 'cssClass', 'useSquare', 'isControlled', 'visualOnly', 'invalid', 'tooltipText'],
		data() {
			return {
				vm: {
					isSelected: false,
				},
				disabledByWizard: false,
			};
		},
		watch: {
			wizardLocks: {
				handler: function () {
					this.disabledByWizard = this.isDisabledByWizard();
				},
				deep: true,
			},
		},
		computed: {
			componentClassName() {
				let className = 'InputCheckbox';
				if (this.invalid == true) className += ' invalid';
				if (this.cssClass && typeof this.cssClass === 'string') className += ` ${this.cssClass}`;

				return className;
			},
			labelClassName() {
				let className = 'input-checkbox';

				if (!this.disabled) className += ' clickable';
				if (this.sfx === false) return className;
				else className += ' sfx';

				return className;
			},
			isInputSelected() {
				return !!this.vm.isSelected;
			},
			util() {
				return util;
			},
		},
		created() {
			this.init();

			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true },
			);
		},
		mounted() {
			this.disabledByWizard = this.isDisabledByWizard();
		},
		methods: {
			init() {
				//double bang; incase some other value other than a bool gets passed in.
				this.vm.isSelected = this.modelValue === null ? this.modelValue : !!this.modelValue;
			},
			onChangeHandler(val) {
				this.$emit('input', val.target.checked);
				// this.$emit('change', this.vm.isSelected);
				this.$emit('update:modelValue', this.vm.isSelected);
			},
			onClickHandler(event) {
				if (this.disabled) return; // InputRadio has it, copyinh it here too. Shouldn't disabled not trigger it anyways?
				this.$emit('click', event.target.checked);
			},
			isDisabledByWizard() {
				if (!this.wizardLocks || !this.$refs.inputCheckbox) return false;
				return this.wizardLocks.isDisabled(this.$refs.inputCheckbox);
			},
		},
	};
</script>

<style>
	.input-checkbox.sfx {
		transition: var(--transition);
	}

	.input-checkbox.sfx:hover {
		color: var(--main-color);
		transition: var(--transition);
	}

	.checkbox {
		position: relative;
		border: 3px solid var(--main-color);
		border-radius: 4px;
		height: 18px;
		width: 18px;
		box-sizing: border-box;
		padding: 2px;
	}

	.input-checkbox-container .checkbox.disabled {
		border: 3px solid var(--black-20percent);
		background-color: var(--input-background-color-disabled);
	}

	.selectedBox {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 2px;
		background: var(--main-color);
		height: 60%;
		width: 60%;
	}

	/*fieldset:not(:disabled) .input-checkbox.sfx:hover {}*/

	fieldset:disabled .input-checkbox.sfx:hover {
		/* No hover effect for disabled fieldset parent */
		cursor: default;
		color: var(--fieldset-input-color-disabled);
		transition: var(--transition);
	}

	.InputCheckbox.invalid .checkbox {
		border-color: var(--error-color);
	}
</style>
